module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABHUlEQVRIx2NgwAv240UMM/GiUaMHndFHRERO6ekdFhI6yMVFTaOB5l6NiLiWkAAkb2dn30hLo47Re6zZjgWLH7dQOWWme8pI84Sp8pEw8f2WbBQbzcFwqkz3ZJLunSkVT5b2P17cf2dyyck0/WP56kApiozea8B0uT/yXK3LpQ7f03UWJ8sML7T5nW/wvTYhAihFkdEnPDSu9EZdqgo4WmZ4doLT2WanYxXGl+oCX+xYfNJDlyKjDwgyHIjlOhomfWty9oUJXhd63W/2pB2JkdkXzgmUojQaT/pq3JpfezbY4oq//5WAgNOBZvfmVZ8J0KdG4mNi2O/MeHf57HtTJ97t77kze+I+V+pmGU3N4452J50dj6ipjZYhI8loAACZP3LdBZd/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/af.png
// module id = 764
// module chunks = 0